import PageBreadcrumb, { Crumb } from './PageBreadcrumb';

interface PageShellProps {
    children: React.ReactNode;
    title: string | React.ReactNode;
    subtitle?: string;
    actions?: React.ReactNode;
    filters?: React.ReactNode;
    breadcrumbs?: Crumb[];
}

export default function PageShell({
    children,
    title,
    subtitle,
    actions,
    filters = null,
    breadcrumbs,
}: PageShellProps) {
    return (
        <main>
            <div className="relative isolate w-full overflow-hidden">
                <header className="pb-6 pt-8">
                    <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 sm:px-6 lg:px-8">
                        {breadcrumbs && breadcrumbs.length > 0 && (
                            <PageBreadcrumb crumbs={breadcrumbs} />
                        )}
                        <div className="flex flex-wrap items-end gap-6 sm:flex-nowrap">
                            <div>
                                <h1 className="text-2xl font-bold tracking-tight text-foreground">
                                    {title}
                                </h1>
                                {subtitle && (
                                    <p className="text-sm leading-6 text-muted-foreground mt-1">
                                        {subtitle}
                                    </p>
                                )}
                            </div>
                            {filters && (
                                <div className="order-last flex w-full gap-x-8 text-sm font-medium leading-6 sm:order-none sm:w-auto sm:border-l sm:border-border sm:pl-6 sm:leading-7">
                                    {filters}
                                </div>
                            )}
                            <div className="flex-1" />
                            {actions}
                        </div>
                    </div>
                </header>
                <div className="max-w-7xl mx-auto">
                    {children}
                </div>
            </div>
        </main>
    );
}
